document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.canvas___template') && document.querySelector('#canvas__div__snippet')) {

    // create canvas html
    let canvas_div = document.createElement('div');
    canvas_div.id = 'canvas____painting';
    canvas_div.classList.add('canvas_painting_main');
    canvas_div.style.display = 'none';
    canvas_div.innerHTML = `
   <div class="canvas____painting____overlay"></div>
     <div id="canvas_close_mob">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.05 3.353a7.511 7.511 0 0 1 5.597 5.597c.47 2.006.47 4.094 0 6.1a7.511 7.511 0 0 1-5.597 5.597c-2.006.47-4.094.47-6.1 0a7.511 7.511 0 0 1-5.597-5.597 13.354 13.354 0 0 1 0-6.1A7.511 7.511 0 0 1 8.95 3.353c2.006-.47 4.094-.47 6.1 0Z" stroke="#0095FF" stroke-width="1.5"/><path d="M15.05 3.353a13.354 13.354 0 0 0-6.1 0A7.511 7.511 0 0 0 3.353 8.95a13.354 13.354 0 0 0 0 6.1 7.511 7.511 0 0 0 5.597 5.597c2.006.47 4.094.47 6.1 0a7.511 7.511 0 0 0 5.597-5.597" stroke="#363853" stroke-width="1.5" stroke-linecap="round"/><path d="m13.768 10.232-3.536 3.536m3.536 0-3.536-3.536" stroke="#0095FF" stroke-width="1.5" stroke-linecap="round"/></svg>
    </div>

    <div class="canvas_wrapper_main">
    <div class="wrapper">
  
      <div class="canvas_image_view_main">
  
        <p id="canvas_floating_text">In het rode vak is de kniplijn aangegeven</p>

          <div class="canvas_zoom_btn">
            <div id="zoomInButton">
              <svg width="44" height="44" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h16v16H0z"/><path d="M15 7H9V1H7v6H1v2h6v6h2V9h6z"/></svg>
            </div>
            <div id="zoomOutButton">
              <svg width="44" height="44" viewBox="0 0 24 24" data-name="Line Color" xmlns="http://www.w3.org/2000/svg" class="icon line-color"><path style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2" d="M19 12H5"/></svg>
            </div>
          </div>
        
        <div class="canvas_image_view">
          <canvas id="imageCanvas" width="800" height="800" style="max-width: 100%; max-height: 600px; height: 90%; filter: brightness(1.1);"></canvas>
          <canvas id="imageCanvas_clear" width="800" height="800" style="max-width: 100%; max-height: 600px; height: 90%; display: none;"></canvas>
        </div>
      </div>
  
      <div class="canvas_painting">
        <div class="canvas_design">
        
          <div class="canvas_design_square canvas_design_inner" painting_shape="Vierkant">
           <div class="canvas_design_img">
            <img src="https://paintwithdiamonds.com/cdn/shop/files/square_48x48_crop_center.png?v=13301099885212245955" alt="square">
           </div>
            <span>Vierkant</span>
          </div>
        
          <div class="canvas_design_round canvas_design_inner" painting_shape="Rond">
            <div class="canvas_design_img">
              <img src="https://paintwithdiamonds.com/cdn/shop/files/round_48x48_crop_center.png?v=16189914888818925831" alt="round">
            </div>
            <span>Rond</span>
          </div>
        </div>
      
        <div id="crop_img">
          <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#fff" fill-opacity=".01" d="M0 0h48v48H0z"/><path d="M12 24h30v18H12V24Z" fill="#2F88FF" stroke="#000" stroke-width="4" stroke-linejoin="round"/><path d="M6 8v9h9" stroke="#000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M38.475 13.299C35.195 8.87 29.933 6 24 6c-5.821 0-10.997 2.763-14.287 7.05L6 17" stroke="#000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span>Bijsnijden</span>
        </div>
        <div id="resetImg"><span>Opnieuw bijsnijden</span></div>
  
        <div class="reUploadImg_file">
          <label For="reUploadImg">Probeer een andere foto</label>
          <input type="file" accept="image/*" id="reUploadImg" />
        </div>
            
        <div id="cartItem" first_var_id="{{ product.first_available_variant.id }}"><span>Voeg toe aan winkelwagen</span></div>
      </div> 
      <div id="canvas_close">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.05 3.353a7.511 7.511 0 0 1 5.597 5.597c.47 2.006.47 4.094 0 6.1a7.511 7.511 0 0 1-5.597 5.597c-2.006.47-4.094.47-6.1 0a7.511 7.511 0 0 1-5.597-5.597 13.354 13.354 0 0 1 0-6.1A7.511 7.511 0 0 1 8.95 3.353c2.006-.47 4.094-.47 6.1 0Z" stroke="#0095FF" stroke-width="1.5"/><path d="M15.05 3.353a13.354 13.354 0 0 0-6.1 0A7.511 7.511 0 0 0 3.353 8.95a13.354 13.354 0 0 0 0 6.1 7.511 7.511 0 0 0 5.597 5.597c2.006.47 4.094.47 6.1 0a7.511 7.511 0 0 0 5.597-5.597" stroke="#363853" stroke-width="1.5" stroke-linecap="round"/><path d="m13.768 10.232-3.536 3.536m3.536 0-3.536-3.536" stroke="#0095FF" stroke-width="1.5" stroke-linecap="round"/></svg>
      </div>
    </div>
    </div>`
    document.body.append(canvas_div);
    ///////////////////////////////////////////////////////////////////////////////////////
    
    const shapeSelectDiv = document.querySelector('.canvas___template .product-single__form .grid-small .product-form__item:first-child select');
    const sizeSelectTheme = document.querySelector('.canvas___template .product-single__form .grid-small .product-form__item:last-child select');

    let sizeSelect = document.createElement('select');
    sizeSelect.classList.add('canvas_size_selector');
    sizeSelect.innerHTML = sizeSelectTheme.innerHTML;
    document.querySelector('.canvas_painting').prepend(sizeSelect);
    
    // main canvas
    const canvas = document.getElementById('imageCanvas');
    const ctx = canvas.getContext('2d');

    // croped image show canvas
    const secondCanvas = document.getElementById('imageCanvas_clear');
    const ctx2 = secondCanvas.getContext('2d');

    // store default image
    const extraCanvas = document.createElement('canvas');
    const extraCanvasCtx = extraCanvas.getContext('2d');

    // bacckgrounbd image canvas
    const bgCanvas = document.createElement('canvas');
    const bgCanvasCtx = bgCanvas.getContext('2d');
    
    let fileInput = document.getElementById('canvas_input');
    const cropButton = document.querySelector('#crop_img span');

    let cropArea = {};
    let canvaImg;
    //////////////////////////////////////////////////////////////////////////


    // upload file
    fileInput.addEventListener('change', handleFileSelect);
    function handleFileSelect(event) {
      file = event.target.files[0];
    
      if (file) {
        initializeCanvas();

        const reader = new FileReader();
    
        reader.onload = function (e) {
          const img = new Image();
          img.src = e.target.result;
          canvaImg = img;
          img.onload = function () {
            
            canvaResoltions(canvas, ctx, img);
            canvaResoltions(extraCanvas, extraCanvasCtx, img);
    
            // background canvas image canvas
            canvaResoltions(bgCanvas, bgCanvasCtx, img);
            bgCanvas.style.cssText = `max-width: 100%; max-height: 600px; height: 100%; position: absolute; width: auto; left: 50%; top: 0; transform: translateX(-50%); filter: saturate(0.8);`;
            document.querySelector('.canvas_image_view').prepend(bgCanvas);
            pixelateCanvas(extraCanvas, bgCanvasCtx, 10);

            // integrate shape iamge
            const bgCanvasImg = new Image();
            bgCanvasImg.src = document.querySelector('.canvas_design_selected')?.classList.contains('canvas_design_round') ? 'https://cdn.shopify.com/s/files/1/0048/6224/6985/files/circle_1.png?v=1703325144' : 'https://cdn.shopify.com/s/files/1/0048/6224/6985/files/square_1_1.png?v=1703325144';

            bgCanvasImg.onload = function () {
              const pattern = bgCanvasCtx.createPattern(bgCanvasImg, 'repeat');
              bgCanvasCtx.fillStyle = pattern;
              bgCanvasCtx.fillRect(0, 0, bgCanvas.width, bgCanvas.height);
            }
            /////////////////////////////////

            updateCropAreaDimensions();

            if (event.target.id === 'reUploadImg') {
              fileInput = document.querySelector('#reUploadImg');
            }

            if (document.querySelector('.canvas_zoom_btn').style.display === 'block') {
              document.querySelector('.canvas_zoom_btn').style.display = 'none';
            }
    
            // Mouse events
            canvas.addEventListener('mousedown', handleStart);
            document.addEventListener('mouseup', handleEnd);
            document.addEventListener('mousemove', handleMove);
    
            // Touch events
            canvas.addEventListener('touchstart', handleStart);
            document.addEventListener('touchend', handleEnd);
            document.addEventListener('touchmove', handleMove);
    
            cropButton.parentElement.style.display = 'flex';
            document.querySelector('.canvas_loading')?.classList.remove('canvas_loading');
            canvas.style.display = 'block';
            document.querySelector('.open__canvas').style.display = 'block';
            document.querySelector('#cartItem').style.display = 'none';
            document.querySelector('#resetImg').style.display = 'none';
            // document.querySelector('.canvas_design').style.display = 'none';
            secondCanvas.style.display = 'none';
            document.querySelector('#resetImg').style.display = 'none';
            document.querySelector('.reUploadImg_file').style.display = 'none';
            document.querySelector('.canvas_painting_rotated') ? document.querySelector('.canvas_painting_rotated').classList.remove('canvas_painting_rotated') : null;
            addToCartBtnWidth();
          };
          img.onerror = function() {
            console.error("Error loading the image");
          };
        };
    
        reader.readAsDataURL(file);
      }
    }
    //////////////////////////////////////////////////////////////////////


    // set canvas/img resoltions
    function canvaResoltions(canvasId, canvasCtx, image) {
      if (canvasId && canvasCtx && image) {

        let imgWidth = image.width; // image width
        let imgHeight = image.height; // image height
  
        // get dimension value
        const selectedDimension = sizeSelect.value.replace(/\s*\(.*?\)\s*/, '').replace('cm', '');
        let [width, height] = selectedDimension.split('x').map(Number);
  
        if (document.querySelector('.canvas_painting_rotated')) {
          [width, height] = [height, width]; // Swap values if rotate is true
        }
  
        const maxDimension = 3800; // max canvas height width
        // if image less then 3800 resplution
        if (imgWidth < maxDimension || imgHeight < maxDimension) { 
          imgWidth = image.width * ((width * 37.79) / image.width);
          imgHeight = image.height * ((width * 37.79) / image.width);
        }
        
        // if image graeter then 3800 resplution
        if (imgWidth > maxDimension || imgHeight > maxDimension) {
          const scaleFactor = Math.min(maxDimension / imgWidth, maxDimension / imgHeight);
          imgWidth *= scaleFactor;
          imgHeight *= scaleFactor;
        }
  
        // get aspact ration calculation
        let { width: calculatedWidth, height: calculatedHeight } = calculateDimensions(imgWidth, imgHeight, width, height);
        // calculate image pixle according dimension
        let maxDimension2 = calculatedWidth > calculatedHeight ? (37.79 * width) * (imgWidth / calculatedWidth) : (37.79 * height) * (imgHeight / calculatedHeight);
  
        if (imgWidth > maxDimension2 || imgHeight > maxDimension2) {
          const scaleFactor = Math.min(maxDimension2 / imgWidth, maxDimension2 / imgHeight);
          imgWidth *= scaleFactor;
          imgHeight *= scaleFactor;
        }
        
        canvasId.width = imgWidth;
        canvasId.height = imgHeight;
        canvasCtx.drawImage(image, 0, 0, canvasId.width, canvasId.height);
      }
    }


    // crop box
    let isDragging = false;
    let startX, startY;

    function handleStart(e) {
      isDragging = true;
      document.querySelector('#canvas____painting .wrapper').style.overflowY = 'hidden';
      startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
      startY = e.type === 'mousedown' ? e.clientY : e.touches[0].clientY;
    }

    function handleEnd() {
      isDragging = false;
      document.querySelector('#canvas____painting .wrapper').style.overflowY = 'auto';
    }

    function handleMove(e) {
      if (isDragging) {        
        const clientX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
        const clientY = e.type === 'mousemove' ? e.clientY : e.touches[0].clientY;
    
        const deltaX = clientX - startX;
        const deltaY = clientY - startY;
    
        let movement = canvas.width / document.querySelector('.canvas_image_view').offsetWidth;
    
        cropArea.x += Math.floor(deltaX * movement);
        cropArea.y += Math.floor(deltaY * movement);
    
        cropArea.x = Math.max(0, Math.min(canvas.width - cropArea.width, cropArea.x));
        cropArea.y = Math.max(0, Math.min(canvas.height - cropArea.height, cropArea.y));
    
        // Only clear and redraw the affected area
        requestAnimationFrame(() => {
          // ctx.clearRect(cropArea.x, cropArea.y, cropArea.width, cropArea.height);
          // canvaResoltions(canvas, ctx, canvaImg);
          // pixelateCanvas(canvas, ctx, 10);
          drawCropArea();
        });
    
        startX = clientX;
        startY = clientY;
      }
    }
    ///////////////////////////////////////////////////////////////////////////

    
    // change diamnations
    sizeSelect.addEventListener('change', function () {
      document.body.classList.add('canvas_loading');
      setTimeout(() => {
        document.querySelector('.canvas_prd_price').innerHTML = document.querySelector('.price-container-desktop').outerHTML;
      }, 0);
    
      canvaResoltions(canvas, ctx, canvaImg);
      canvaResoltions(extraCanvas, extraCanvasCtx, canvaImg);
      
      canvaResoltions(bgCanvas, bgCanvasCtx, canvaImg);
      pixelateCanvas(extraCanvas, bgCanvasCtx, 10);

      const bgCanvasImg = new Image();
      bgCanvasImg.src = document.querySelector('.canvas_design_selected')?.classList.contains('canvas_design_round') ? 'https://cdn.shopify.com/s/files/1/0048/6224/6985/files/circle_1.png?v=1703325144' : 'https://cdn.shopify.com/s/files/1/0048/6224/6985/files/square_1_1.png?v=1703325144';

      bgCanvasImg.onload = function () {
        const pattern = bgCanvasCtx.createPattern(bgCanvasImg, 'repeat');
        bgCanvasCtx.fillStyle = pattern;
        bgCanvasCtx.fillRect(0, 0, bgCanvas.width, bgCanvas.height);
        document.querySelector('.canvas_loading')?.classList.remove('canvas_loading');
      }
      
      updateCropAreaDimensions();
    
      document.querySelector(`.canvas___template [value="${sizeSelect.value}"]`).selected = true;
      const changeEvent = new Event('change');
      sizeSelectTheme.dispatchEvent(changeEvent);
    });
    ////////////////////////////////////////////////////////////////////////////////

    
    // update crop box diamnations
    function updateCropAreaDimensions() {
      if (canvaImg) {
        requestAnimationFrame(() => {
          // ctx.clearRect(0, 0, canvas.width, canvas.height);
          // canvaResoltions(canvas, ctx, canvaImg);
          // ctx.drawImage(canvaImg, 0, 0);
          // pixelateCanvas(canvas, ctx, 10);
          drawCropArea();
        });
      }

      const selectedDimension = sizeSelect.value.replace(/\s*\(.*?\)\s*/, '').replace('cm', '');
      let [width, height] = selectedDimension.split('x').map(Number);

      if (document.querySelector('.canvas_painting_rotated')) {
        [width, height] = [height, width]; // Swap values if rotate is true
      }

      let { width: calculatedWidth, height: calculatedHeight } = calculateDimensions(canvas.width, canvas.height, width, height);
      
      cropArea = {
        x: 0,
        y: 0,
        width: calculatedWidth,
        height: calculatedHeight,
      }
      drawCropArea();
    }
    /////////////////////////////////////////////////////////////////////////////

    
    // draw crop box
    function drawCropArea() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // ctx.lineWidth = 1 * canvas.width;
      // ctx.strokeStyle = 'rgba(0, 0, 0, 0.8)';
      // ctx.strokeRect(0, 0, canvas.width, canvas.height);

      ctx.lineWidth = (0.01 * canvas.width);
      ctx.strokeStyle = '#f00';
      ctx.strokeRect(cropArea.x, cropArea.y, cropArea.width, cropArea.height);
      
      // ctx.fillStyle = 'rgba(255, 255, 255, 0.4)'; // White with 0.6 opacity
      // ctx.fillRect(cropArea.x, cropArea.y, cropArea.width, cropArea.height);
    }
    /////////////////////////////////////////////////////////////////////////////


    // calculate diamnations area
    function calculateDimensions(containerWidth, containerHeight, widthRatio, heightRatio) {
      if (widthRatio <= 0 || heightRatio <= 0) {
        // Handle invalid aspect ratio
        console.error('Invalid aspect ratio.');
        return null;
      }
    
      let width, height;
      // Calculate width and height based on the aspect ratio
      width = Math.min(containerWidth, containerHeight * (widthRatio / heightRatio));
      height = width / (widthRatio / heightRatio);

      // console.log(containerWidth, width, containerHeight, height);
    
      return { width, height };
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////


    // rotate crop
    document.querySelector('#crop_img svg').addEventListener('click', function () {
      document.querySelector('.canvas_painting').classList.toggle('canvas_painting_rotated');
      updateCropAreaDimensions()
    });
    ////////////////////////////////////////////////////////////////////////////////////////////////


    // crop image
    cropButton.addEventListener('click', function handleCrop() {
      // Remove the event listeners
      canvas.removeEventListener('mousedown', handleStart);
      document.removeEventListener('mouseup', handleEnd);
      document.removeEventListener('mousemove', handleMove);
    
      canvas.removeEventListener('touchstart', handleStart);
      document.removeEventListener('touchend', handleEnd);
      document.removeEventListener('touchmove', handleMove);

      const croppedImage = document.createElement('canvas');
      const croppedCtx = croppedImage.getContext('2d');

      const selectedDimension = sizeSelect.value.replace(/\s*\(.*?\)\s*/, '').replace('cm', '');
      let [width, height] = '';         
      
      let rotated = document.querySelector('.canvas_painting_rotated');
      rotated ? [height, width] = selectedDimension.split('x').map(Number) : [width, height] = selectedDimension.split('x').map(Number);
      // [width, height] = selectedDimension.split('x').map(Number);

      width = Math.floor(width * 37.79);
      height = Math.floor(height * 37.79);
      
      croppedImage.width = width;
      croppedImage.height = height;

      croppedCtx.drawImage(extraCanvas, cropArea.x, cropArea.y, cropArea.width, cropArea.height, 0, 0, width, height);
    
      // Display the cropped image on the canvas
      canvas.width = width;
      canvas.height = height;
      // ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(croppedImage, 0, 0);

      // second canvas
      secondCanvas.width = canvas.width;
      secondCanvas.height = canvas.height;
      ctx2.drawImage(canvas, 0, 0);
      pixelateCanvas(canvas, ctx2, 10);
 
      // Load the image from the provided URL
      const img = new Image();
      img.src = document.querySelector('.canvas_design_selected')?.classList.contains('canvas_design_round') ? 'https://cdn.shopify.com/s/files/1/0048/6224/6985/files/circle_1.png?v=1703325144' : 'https://cdn.shopify.com/s/files/1/0048/6224/6985/files/square_1_1.png?v=1703325144';

      img.onload = function () {
        const pattern = ctx2.createPattern(img, 'repeat');
        ctx2.fillStyle = pattern;
        ctx2.fillRect(0, 0, width, height);

        // sizeSelect.style.display = 'none';
        cropButton.parentElement.style.display = 'none';
        document.querySelector('#cartItem').style.display = 'block';
        document.querySelector('.canvas_loading')?.classList.remove('canvas_loading');
        canvas.style.display = 'none';
        secondCanvas.style.display = 'block';
        document.querySelector('#resetImg').style.display = 'inline-block';
        document.querySelector('.reUploadImg_file').style.display = 'inline-block';
        sizeSelect.style.display = 'none';
        document.querySelector('.canvas_prd_price.select_box_content')?.classList.remove('select_box_content');
        // document.querySelector('.canvas_design').style.display = 'flex';
        document.querySelector('.canvas_zoom_btn').style.display = 'block';
        addToCartBtnWidth();
      };
    });
    ////////////////////////////////////////////////////////////////////////////////////////////////
  

    // upload file to server
    document.querySelector('#cartItem').addEventListener('click', uploadFile);
    async function uploadFile() {
      try {

        document.querySelector('#cartItem').classList.add('adding_item')
        let canvas = document.getElementById('imageCanvas');
        let dataURL = canvas.toDataURL('image/jpeg', 0.8); // Adjust the quality (0.8 for 80% quality)
  
        // Convert the data URL to a Blob object
        let blob = dataURItoBlob(dataURL);
  
        // Create a FormData object and append the Blob
        let formData = new FormData();
        formData.append('image', blob, 'image.jpg');
  
        // Send the FormData to the server using fetch
        const response = await fetch('https://canvas-7385479d07bb.herokuapp.com/upload', {
          method: 'POST',
          body: formData
        });

        const result = await response.json();

        if (!result.shopifyImgUrl) {
          location.reload();
        }
        else{
           // get variant id
          let variantId = new URL(window.location.href).searchParams.get("variant") || document.querySelector('#cartItem').getAttribute('first_var_id');        
  
          let data = {
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  image: result.shopifyImgUrl
                }
              }
            ]
          };
          addToCart(data); 
        }
  
      } catch (error) {
        console.error('Error:', error);
      }
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////
  
  
    // Function to convert data URL to Blob
    function dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: 'image/jpeg' });
    } 
    ////////////////////////////////////////////////////////////////////////////////////////////////
  
  
    // add to cart
    async function addToCart(items) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(items)
        });
  
        // Handle the response as needed
        if (response.ok) {
          window.location.href = '/cart';
        } else {
          console.error('Failed to add to cart:', response.statusText);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////
  
    
    // channge pixle type
    document.querySelectorAll('.canvas_design_inner').forEach(elm => {
      elm.addEventListener('click',function(){
        document.body.classList.add('canvas_loading');

        if (document.querySelector('.canvas_design_selected')) {
          document.querySelector('.canvas_design_selected').classList.remove('canvas_design_selected');
        }
        this.classList.add('canvas_design_selected');

        // Load the image from the provided URL
        const img = new Image();
        img.src = this.classList.contains('canvas_design_round') ? 'https://cdn.shopify.com/s/files/1/0048/6224/6985/files/circle_1.png?v=1703325144' : 'https://cdn.shopify.com/s/files/1/0048/6224/6985/files/square_1_1.png?v=1703325144';

        if (document.querySelector('#crop_img').style.display === 'flex') {
          bgCanvasCtx.drawImage(extraCanvas, 0, 0);
          pixelateCanvas(extraCanvas, bgCanvasCtx, 10);

          img.onload = function () {
            const pattern2 = bgCanvasCtx.createPattern(img, 'repeat');
            bgCanvasCtx.fillStyle = pattern2;
            bgCanvasCtx.fillRect(0, 0, bgCanvas.width, bgCanvas.height);
            document.querySelector('.canvas_loading')?.classList.remove('canvas_loading');
          }
        }
        else{
          const clearCanvas = secondCanvas;
          clearCanvas.width = canvas.width;
          clearCanvas.height = canvas.height;
  
          const ctx2 = clearCanvas.getContext('2d');
          ctx2.drawImage(canvas, 0, 0);
          pixelateCanvas(canvas, ctx2, 10);

          img.onload = function () {
            const pattern = ctx2.createPattern(img, 'repeat');
            ctx2.fillStyle = pattern;
            ctx2.fillRect(0, 0, clearCanvas.width, clearCanvas.height);
            document.querySelector('.canvas_loading')?.classList.remove('canvas_loading');
          }
        }

        shapeSelectDiv.querySelector(`[value="${this.getAttribute('painting_shape')}"]`).selected = true;
        const changeEvent = new Event('change');
        shapeSelectDiv.dispatchEvent(changeEvent);
      });
    });
    ////////////////////////////////////////////////////////////////////////////////////////////////
  

    // resize image
    document.querySelector('#resetImg').addEventListener('click', function(){
      document.querySelector('.canvas_painting_rotated') ? document.querySelector('.canvas_painting_rotated').classList.remove('canvas_painting_rotated') : null;
      document.querySelector('.canvas_zoom_btn').style.display = 'none';
      zoomLevel = 1;
      updateZoom()
      const changeEvent = new Event('change');
      fileInput.dispatchEvent(changeEvent);
    });
    // reupload image
    document.querySelector('#reUploadImg').addEventListener('change', handleFileSelect);
    /////////////////////////////////////////////////////////////////////////////////////////


    // create pixle
    function pixelateCanvas(sourceCanvas, targetCanvas, pixelSize) {
      const sourceCanvasCtx = sourceCanvas.getContext('2d');
      const imageData = sourceCanvasCtx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
      const data = imageData.data;
    
      const targetImageData = sourceCanvasCtx.createImageData(sourceCanvas.width, sourceCanvas.height);
      const targetData = targetImageData.data;
    
      for (let y = 0; y < sourceCanvas.height; y += pixelSize) {
        for (let x = 0; x < sourceCanvas.width; x += pixelSize) {
          const red = data[(y * sourceCanvas.width + x) * 4];
          const green = data[(y * sourceCanvas.width + x) * 4 + 1];
          const blue = data[(y * sourceCanvas.width + x) * 4 + 2];
          const alpha = data[(y * sourceCanvas.width + x) * 4 + 3]; // Get the alpha value
    
          for (let n = 0; n < pixelSize; n++) {
            for (let m = 0; m < pixelSize; m++) {
              const targetX = Math.min(x + m, sourceCanvas.width - 1);
              const targetY = Math.min(y + n, sourceCanvas.height - 1);
              const index = (targetY * sourceCanvas.width + targetX) * 4;
    
              // Use grey color for transparent pixels, otherwise use original color
              targetData[index] = alpha === 0 ? 128 : red;
              targetData[index + 1] = alpha === 0 ? 128 : green;
              targetData[index + 2] = alpha === 0 ? 128 : blue;
              targetData[index + 3] = alpha;  // Preserve alpha value
            }
          }
        }
      }
      targetCanvas.putImageData(targetImageData, 0, 0);
    }
    ///////////////////////////////////////////////////////////////////////////////////////////


    // helper function use in file upload
    function initializeCanvas() {
      document.body.classList.add('canvas_overflow_hidden');

      zoomLevel = 1;
      updateZoom()
      
      document.querySelector(`.canvas_size_selector [value="${sizeSelectTheme.value}"]`).selected = true;
      const changeEvent = new Event('change');
      sizeSelect.dispatchEvent(changeEvent);
      
      if (!document.querySelector('.canvas_prd_price')) {          
        let prdPrice = document.createElement('div');
        prdPrice.classList.add('canvas_prd_price','select_box_content');
        prdPrice.innerHTML = document.querySelector('.price-container-desktop').outerHTML;
        document.querySelector('.canvas_painting').prepend(prdPrice);
      }

      if (!document.querySelector('.canvas_prd_title')) {
        let prdTitle = document.createElement('h2');
        prdTitle.classList.add('canvas_prd_title')
        prdTitle.innerHTML = document.querySelector('.product-single__title').innerHTML;
        document.querySelector('.canvas_painting').prepend(prdTitle);
      }

      document.body.classList.add('canvas_loading');
      document.querySelector('.canvas_input_file_div').style.display = 'none';
      document.querySelector('#canvas____painting').style.display = 'block';
      sizeSelect.style.display = 'block';
      document.querySelector('.canvas_prd_price')?.classList.add('select_box_content');

      document.querySelector(`[painting_shape="${shapeSelectDiv.value}"]`).classList.add('canvas_design_selected');
    }
    ////////////////////////////////////////////////////////////////////////////////

    
    // Add event listeners for zoom buttons
    const zoomInButton = document.getElementById('zoomInButton');
    const zoomOutButton = document.getElementById('zoomOutButton');
    let zoomLevel = 1;

    // zoom in
    zoomInButton.addEventListener('click', function () {
      zoomLevel *= 1.3; // Increase the zoom level (adjust the factor as needed)
      secondCanvas.style.cursor = 'grab';
      updateZoom();
    });

    // zoom out
    zoomOutButton.addEventListener('click', function () {
      zoomLevel *= 0.7; // Decrease the zoom level (adjust the factor as needed)
      if (zoomLevel <= 1){
        zoomLevel = 1;
        secondCanvas.style.cursor = 'unset';
      }
      updateZoom();
    });

    // zoom in out function
    let scrol_top, scrol_left;
    function updateZoom() {      
      // secondCanvas.style.transform = `matrix(${zoomLevel}, 0, 0, ${zoomLevel}, ${translateX}, ${translateY})`;
      
      let height = document.querySelector('.canvas_image_view').offsetHeight;
      let width = document.querySelector('.canvas_image_view').offsetWidth;
    
      let overflowHeight = height * zoomLevel;
      let overflowWidth = width * zoomLevel;

      scrol_top = (overflowHeight - height) / 2;
      scrol_left = (overflowWidth - width) / 2;
      
      secondCanvas.style.transform = `scale(${zoomLevel})`;      
      secondCanvas.style.transformOrigin = 'top left';

      document.querySelector('.canvas_image_view').scrollLeft = scrol_left;
      document.querySelector('.canvas_image_view').scrollTop = scrol_top;
    }

    let isScroll = false;
    let scrollStartX, scrollStartY;
    
    // desktop zoom image move listner
    secondCanvas.addEventListener('mousedown', scrollStartFn);
    document.addEventListener('mouseup', scrollEndFn);
    secondCanvas.addEventListener('mousemove', scrollMoveFn);
    
    // movement start
    function scrollStartFn(event) {
      if (zoomLevel > 1){
        isScroll = true;
        scrollStartX = event.clientX;
        scrollStartY = event.clientY;
      }
    }
    
    // movement end
    function scrollEndFn() {
      isScroll = false;
    }

    // find movement area
    function scrollMoveFn(event) {
      if (isScroll) {
        const deltaX = event.clientX - scrollStartX;
        const deltaY = event.clientY - scrollStartY;

        updateScroll(deltaX, deltaY);
    
        scrollStartX = event.clientX;
        scrollStartY = event.clientY;
      }
    }

    // move zoom image
    function updateScroll(deltaX, deltaY) {
      scrol_left = scrol_left - deltaX;
      scrol_top = scrol_top - deltaY;
    
      document.querySelector('.canvas_image_view').scrollLeft = scrol_left;
      document.querySelector('.canvas_image_view').scrollTop = scrol_top;
    }
    ////////////////////////////////////////////////////////////////////////


    // open canvas popup
    document.querySelector('.open__canvas').addEventListener('click', () => {
      document.querySelector('#canvas____painting').style.display = 'block';
      document.body.classList.add('canvas_overflow_hidden');
    });
    
    // close canvas listner
    document.querySelector('#canvas_close').addEventListener('click', closeCanvas);
    document.querySelector('#canvas_close_mob svg').addEventListener('click', closeCanvas);
    document.querySelector('.canvas____painting____overlay').addEventListener('click', closeCanvas);
    
    // close canvas popup
    function closeCanvas() {
      document.querySelector('#canvas____painting').style.display = 'none';
      document.querySelector('.canvas_overflow_hidden')?.classList.remove('canvas_overflow_hidden');
    }
    ////////////////////////////////////////////////////////////////////////////////


    // add to cart button set width
    function addToCartBtnWidth() {
      // setTimeout(() => {
        if (window.matchMedia( "(max-width: 1024px)" ).matches) {
          document.querySelector('#cartItem').style.maxWidth = (document.querySelector('.canvas_design').offsetWidth + 10) + 'px';
          document.querySelector('#crop_img').style.maxWidth = (document.querySelector('.canvas_design').offsetWidth + 10) + 'px';
          document.querySelector('.canvas_design').style.marginBottom = document.querySelector('#crop_img').style.display === 'flex' ? '56px' : '20px';
        }
        else{
          document.querySelector('#cartItem').style.maxWidth = 'unset';
          document.querySelector('#crop_img').style.maxWidth = 'unset';
          document.querySelector('.canvas_design').style.marginBottom = '20px';
        }
      // }, 100);
    }

    window.addEventListener('resize', addToCartBtnWidth);

  }
});
